import React from 'react';
import { LinkParagraph } from '@nexus/lib-react/dist/core/Link/LinkParagraph';
import { Dac7ProfileWrapper, Title, GreenText } from './components/style/Dac7Profile';
import { useI18n } from '../../../../i18n';
import Style from './style/Dac7ContentSuccess';
import DocumentIcon from './assets/document.svg';
import SearchAvatarIcon from './assets/search-avatar.svg';
import Dac7EyeHiddenTooltip from './components/Dac7EyeHiddenTooltip';

interface Props {
  deepLink: string;
}

export default ({ deepLink }: Props) => {
  const i18n = useI18n();

  return (
    <Dac7ProfileWrapper>
      <Title>
        {i18n('dlv_dac7_profile_title_details').toUpperCase()} <Dac7EyeHiddenTooltip />{' '}
        <GreenText>{i18n('dlv_dac7_profile_submitted')}</GreenText>
      </Title>
      <Style.StepsContainer>
        {/* ---------------------- Step 1 ---------------------- */}
        <Style.StepContainer>
          <Style.IconWrapper>
            <DocumentIcon />
          </Style.IconWrapper>
          <Style.StepInfoContainer>
            <Style.P2>{i18n('dlv_dac7_success_step1_title')}</Style.P2>
            <Style.P3>{i18n('dlv_dac7_success_step1_description')}</Style.P3>
          </Style.StepInfoContainer>
        </Style.StepContainer>

        {/* ---------------------- Step 2 ---------------------- */}
        <Style.StepContainer>
          <Style.IconWrapper>
            <SearchAvatarIcon />
          </Style.IconWrapper>
          <Style.StepInfoContainer>
            <Style.P2>{i18n('dlv_dac7_success_step2_title')}</Style.P2>
            <Style.P3>{i18n('dlv_dac7_success_step2_description')}</Style.P3>
          </Style.StepInfoContainer>
        </Style.StepContainer>
      </Style.StepsContainer>

      <LinkParagraph href={deepLink}>{i18n('dlv_dac7_profile_see_details')}</LinkParagraph>
    </Dac7ProfileWrapper>
  );
};
